import { call, put, takeLatest } from 'redux-saga/effects';
import { callApiV2WithNoAuth } from '../../api/Api';
import { CHECK_EUA_AVAILABILITY, setEuaCheckAvailability, setEuaCheckAvailabilityError } from './action';

export function* callCheckEuaAvailability(action) {
  try {
    const response = yield call(callApiV2WithNoAuth, {
      method: 'GET',
      url: `/eua/${action.payload}/check-availability`,
    });
    yield put(setEuaCheckAvailability(response.data));
  } catch (err) {
    yield put(setEuaCheckAvailabilityError(true));
  }
}

export function* watchCheckEuaAvailability() {
  yield takeLatest(CHECK_EUA_AVAILABILITY, callCheckEuaAvailability);
}
